import { useId } from "react";

/**
 * Klantpunt-beeldmerk: punt + chevron met het paars-roze verloop (brand/klantpunt/beeldmerk.svg).
 * Werkt op licht en donker.
 */
export function BrandMark({ size = 32, title }: { size?: number; title?: string }) {
  const id = useId();
  return (
    <svg
      className="brandmark"
      viewBox="619.9 593.1 130 130"
      width={size}
      height={size}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <defs>
        <linearGradient id={id} x1="621" y1="613" x2="749" y2="703" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#c15eff" />
          <stop offset="1" stopColor="#ff79ff" />
        </linearGradient>
      </defs>
      <g fill={`url(#${id})`}>
        <path d="M706.64,700.96h42.15l-28.51-43.66,28.51-43.66h-42.15c-2.72,0-5.25,1.37-6.73,3.64l-26.14,40.02,26.14,40.02c1.48,2.27,4.02,3.64,6.73,3.64Z" />
        <circle cx="644.63" cy="678.79" r="23.65" />
      </g>
    </svg>
  );
}
